import { Paragraph, Row, useTranslation } from '@packages/utils';
import { TColumnType } from 'components/Base/Table/Table.types';
import {
  EMeetingsColumnKey,
  TElcDetailUI,
  TMeetingsUI,
} from 'data/types/elcs.types';
import { SharedIcon } from 'components/Base/Icon';
import RemoveMeeting from './MeetingsActions/RemoveMeeting';
import EditMeeting from './MeetingsActions/EditMeeting';

const useGetData = (elcId: TElcDetailUI['elcId'], isEditable?: boolean) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.list.table.title',
  });

  const defaultColumns: TColumnType<TMeetingsUI>[] = [
    {
      title: t('MEETING'),
      dataIndex: 'title',
      key: 'title',
      onCell: () => ({
        style: {
          maxWidth: '300px',
        },
      }),
      render: (text: string, record: TMeetingsUI) => (
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Paragraph
            ellipsis={{ tooltip: text }}
            style={{
              marginBottom: 0,
              flex: 1,
              minWidth: 0,
              paddingRight: record.isGlobal ? 24 : 0,
            }}
          >
            {text}
          </Paragraph>
          {record.isGlobal && (
            <SharedIcon
              size={18}
              style={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: t('MEETING_DATE'),
      dataIndex: 'date',
      sorter: true,
      key: EMeetingsColumnKey.DATE,
    },
    {
      title: t('LAST_UPDATE'),
      dataIndex: 'lastUpdateDate',
      key: 'lastUpdateDate',
      ellipsis: true,
    },
    ...(isEditable
      ? [
          {
            title: t('ACTIONS'),
            key: 'actions',
            dataIndex: 'actions',
            fixed: 'right',
            width: 120,
            onCell: () => ({
              style: { minWidth: '120px' },
              onClick: e => {
                e.stopPropagation();
              },
            }),
            render: (text, record: TMeetingsUI) => (
              <Row justify="center" gutter={[12, 12]} wrap={false}>
                <div data-cy="meeting_edit_btn">
                  <EditMeeting
                    initialValues={{
                      date: record.date,
                      title: record.title,
                      scope: record.isGlobal ? 'ALL_ELCS' : 'USER_LEAD_ELCS',
                    }}
                    elcId={elcId}
                    meetingId={record.meetingId}
                    disabled={record.isGlobal}
                  />
                </div>
                <div data-cy="meeting_delete_btn">
                  <RemoveMeeting
                    elcId={elcId}
                    meetingId={record.meetingId}
                    disabled={record.isGlobal}
                  />
                </div>
              </Row>
            ),
          } as TColumnType<TMeetingsUI>,
        ]
      : []),
  ];
  return { defaultColumns };
};

export default useGetData;
